module.exports = __webpack_public_path__ + "img/video-white.9251fad8.svg";